import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import type { GetTrialIdentityByIdResponse } from "src/api/Tmd.dtos";
import useTrialIdentityById from "src/hooks/data/load/useTrialIdentityById";
import type { SWRConfiguration } from "swr";

interface ITrialProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<GetTrialIdentityByIdResponse, GetTrialIdentityByIdResponse>;
}

const TrialIdentityProvider: FC<ITrialProviderProps> = ({ children, id, configuration }) => {
    const context = useTrialIdentityById(id, configuration);

    return (
        <TrialIdentityContext.Provider value={context}>{children}</TrialIdentityContext.Provider>
    );
};

export const RouteTrialIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { trialId } = useParams<{ trialId: string }>();
    const id = trialId ? parseInt(trialId, 10) : undefined;

    return <TrialIdentityProvider id={id}>{children}</TrialIdentityProvider>;
};

export default TrialIdentityProvider;
